// extracted by mini-css-extract-plugin
export default {"contactInfo":"pEj71zpFwU3NDKczYjI7","advisor":"jjsGfuJu3Pm2iZ4Aj7kt","advisorPlaceholder":"njlJety8xuDSQQ7FM6Hm","details":"uM3ETyrY1nc0PcXeOh8z"};